var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import _ from 'lodash';
import { useMemo, useCallback, useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Driver } from '@/components/functional/driver/Driver';
import { RfpCliOfferPdfTooltipOne } from '@/components/modules/pages/rfp/client/Tooltip/RfpCliOfferPdfTooltip';
import { RfpCliOfferViewTooltipOne, RfpCliOfferViewTooltipTwo, RfpCliOfferViewTooltipThree, } from '@/components/modules/pages/rfp/client/Tooltip/RfpCliOfferViewTooltip';
import { useDidMount } from '@/hooks/lifecycle/useDidMount';
import { useMatchMedia } from '@/hooks/style/useMatchMedia';
import { useDriverSettings } from '@/hooks/ui/functional/useDriverSettings';
import { DRIVER_PORTAL_ROOT_CLASS } from '@/utils/constants/ui/driver';
import { apiCreateClientOfferDetailViewEvent, apiCreateClientOfferViewEvent, apiGetOneClientOfferDownloadOne, } from '../../../../actions/ClientRfpActions';
import { OFFER_STATUS_SELECTION } from '../../../../define/consts/rfp';
import { RFP_EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT, RFP_EVENT_TYPE_CLIENT_OFFER_VIEW, } from '../../../../define/consts/rfp/rfp_event';
import { wrapDispatch } from '../../../../helpers/action';
import { propArrayShape, propShape, propMatch, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { isRfpTypePublicOffer } from '../../../../helpers/rfp';
import { useBoolState } from '../../../../helpers/use/useHook';
import UserPreviewState from '../../../../helpers/user/UserPreviewState';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import FullScreenImageViewerModal from '../../../Ui/Modal/FullScreenModal/ImageViewer/FullScreenImageViewerModal';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import AdditionalFilesRow from './Parts/AdditionalFiles/AdditionalFilesRow';
import SendOffModal from './Parts/Interview/Modal/SendOffModal';
import MemberRows from './Parts/Member/MemberRows';
import OfferOneBottom from './Parts/OfferOne/Bottom/OfferOneBottom';
import CompanyRow from './Parts/OfferOne/Company/CompanyRow';
import RfpOneDescriptionFixedRow from './Parts/OfferOne/Description/RfpOneDescriptionFixedRow';
import RfpOneDescriptionRow from './Parts/OfferOne/Description/RfpOneDescriptionRow';
import RightComponent from './Parts/OfferOne/Modal/RightComponent';
import RfpOneFooterNavSp from './Parts/OfferOne/Nav/RfpOneFooterNavSp';
import RfpOneHeaderNavPc from './Parts/OfferOne/Nav/RfpOneHeaderNavPc';
import RfpOneSkeleton from './RfpOneSkeleton';
import { rfpCharmPointUseCase } from './UseCase/RfpCharmPointUseCase';
import { rfpOneOfferPageViewUseCase } from './UseCase/RfpOneOfferPageViewUseCase';
import { rfpOneUseCase } from './UseCase/RfpOneUseCase';
import { rfpSendOffModalUseCase } from './UseCase/RfpSendOffModalUseCase';
const RfpOneOfferDetail = (props) => {
    const { match: { params: { id, viewRequestId }, }, offers, rfp, } = props;
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const { isDisabledAction: rawIsDisabledAction, isMember } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    /** プレビュー表示か（管理画面確認用） */
    const { isPreview } = UserPreviewState;
    const isDisabledAction = isPreview || rawIsDisabledAction;
    const viewRequest = useMemo(() => offers.find((v) => v.id.toString() === viewRequestId), [offers, viewRequestId]);
    const averagePrice = useMemo(() => Math.round(_.meanBy(offers, (v) => v.offer.price)), [offers]);
    const averagePeriod = useMemo(() => Math.round(_.meanBy(offers, (v) => v.offer.period)), [offers]);
    const { is_end: isEnd, is_show_warn_charm_point: isShowWarnCharmPoint, name, } = rfp;
    const { offer, offer_members: offerMembers, organization_name: organizationName, } = viewRequest;
    const { charm_points: charmPoints, confirm_comment: confirmComment, file_images: fileImages, good_point_comment: goodPointComment, is_view: isView, status, } = offer;
    const dispatch = useDispatch();
    const onClickDownload = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiGetOneClientOfferDownloadOne(id, viewRequestId, `${name}_${organizationName}.zip`));
    }), [dispatch, id, viewRequestId, name, organizationName]);
    const { screenKey } = useMatchMedia();
    const isPc = useMemo(() => ['md', 'lg', 'xl'].includes(screenKey), [screenKey]);
    // フルスクリーンモーダル Driver 表示制御
    const [isShowWarnCharmPointState, changeIsShowWarnCharmPointState] = useState(isShowWarnCharmPoint || false);
    const { boolState: isShowFullModal, changeFalse: rawHideFullModal, changeTrue: showFullModal, } = useBoolState();
    /** Driver（フルスクリーンモーダル用） 表示対象の Ref */
    const driverOfPdfTargetOneRef = useRef(null);
    const { changeDriverState: changeDriverOfPdfState, driverRef: driverOfPdfRef, getIsActiveDriverTarget: getIsActiveDriverOfPdfTarget, isShowDriver: isShowDriverOfPdf, showDriver: showDriverOfPdf, stopDriver: stopDriverOfPdf, } = useDriverSettings();
    /** Driver（フルスクリーンモーダル用） 設定 */
    const driverOfPdfSettings = useMemo(() => [
        {
            onClickOverlay: stopDriverOfPdf,
            ref: isShowFullModal ? driverOfPdfTargetOneRef : { current: null },
            scrollOffset: 90,
            tooltip: _jsx(RfpCliOfferPdfTooltipOne, { onClickButton: stopDriverOfPdf }),
            tooltipDisplayPosition: 'left',
        },
    ], [isShowFullModal, stopDriverOfPdf]);
    const { charmPointValue, isEnabledCharmPoint, onChangeCompleteInputRange, onChangeInputRange, } = rfpCharmPointUseCase.useCharmPoint(rfp, viewRequest, isMember, dispatch);
    const hideFullModal = useCallback((e) => {
        e.stopPropagation();
        const isInput = charmPointValue || isShowWarnCharmPointState;
        // 魅了度 未入力の場合 警告表示（初回 かつ PC表示のみ）
        if (!isDisabledAction && !isInput && isPc) {
            showDriverOfPdf();
            // 1度表示したら表示しない
            changeIsShowWarnCharmPointState(true);
            dispatch(apiCreateClientOfferViewEvent(id, RFP_EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT));
            return;
        }
        if (isDisabledAction || isInput || !isPc) {
            rawHideFullModal();
        }
    }, [
        charmPointValue,
        dispatch,
        id,
        isDisabledAction,
        isPc,
        isShowWarnCharmPointState,
        rawHideFullModal,
        showDriverOfPdf,
    ]);
    const { hideSendOffModal, isShowSendOffModal, modalValue, onSubmitSendOff, showSendOffModal, } = rfpSendOffModalUseCase.useSendOffModal(id, dispatch);
    const currentIndex = useMemo(() => offers.findIndex((v) => v.id.toString() === viewRequestId), [offers, viewRequestId]);
    const prevViewRequest = useMemo(() => offers[currentIndex - 1] || {}, [offers, currentIndex]);
    const nextViewRequest = useMemo(() => offers[currentIndex + 1] || {}, [offers, currentIndex]);
    const offerTitle = `${organizationName}からのご提案`;
    const pans = useMemo(() => [
        // プレビュー表示の場合、他ページへの導線を切っておく
        {
            link: isPreview ? undefined : '/mypage/project',
            text: 'マイページ',
        },
        {
            link: isPreview ? undefined : `/project/client/${id}/interview/view`,
            text: name,
        },
        {
            text: offerTitle,
        },
    ], [id, name, offerTitle, isPreview]);
    const onClickSendOff = useCallback(() => {
        showSendOffModal([viewRequest]);
    }, [showSendOffModal, viewRequest]);
    /** Driver 表示対象の Ref */
    const driverTargetOneRef = useRef(null);
    const driverTargetTwoRef = useRef(null);
    const driverTargetThreeRef = useRef(null);
    const { changeDriverState, changeDriverTarget, driverRef, getIsActiveDriverTarget, isShowDriver, resetDriver, showDriver, stopDriver, } = useDriverSettings();
    /** Driver 設定 */
    const driverSettings = useMemo(() => [
        {
            onClickOverlay: changeDriverTarget,
            ref: driverTargetOneRef,
            scrollOffset: 250,
            tooltip: (_jsx(RfpCliOfferViewTooltipOne, { onClickButton: changeDriverTarget })),
        },
        {
            onClickOverlay: isPc ? changeDriverTarget : stopDriver,
            ref: driverTargetTwoRef,
            scrollOffset: 220,
            tooltip: (_jsx(RfpCliOfferViewTooltipTwo, { onClickButton: isPc ? changeDriverTarget : stopDriver })),
        },
        {
            onClickOverlay: changeDriverTarget,
            ref: driverTargetThreeRef,
            scrollOffset: 90,
            tooltip: (_jsx(RfpCliOfferViewTooltipThree, { onClickButton: changeDriverTarget })),
            tooltipDisplayPosition: 'left',
        },
    ], [
        changeDriverTarget,
        driverTargetOneRef,
        driverTargetThreeRef,
        driverTargetTwoRef,
        isPc,
        stopDriver,
    ]);
    // アクセス履歴に応じたコーチマークの表示
    useDidMount(() => {
        let active = true;
        const hasView = offers.some((v) => v.offer.is_view);
        if (isPc && !UserPreviewState.isPreview && !hasView && active) {
            showDriver();
        }
        return () => {
            active = false;
            resetDriver();
        };
    });
    // レスポンシブの Driver 表示制御
    useEffect(() => {
        if (isPc) {
            return;
        }
        // 表示中にSP幅に変更された場合、 チュートリアル表示終了
        if (isShowDriver) {
            stopDriver();
        }
        // 表示中にSP幅に変更された場合、 フルスクリーンモーダルの警告表示終了
        if (isShowDriverOfPdf) {
            stopDriverOfPdf();
        }
    }, [
        isPc,
        isShowDriver,
        isShowDriverOfPdf,
        getIsActiveDriverTarget,
        getIsActiveDriverOfPdfTarget,
        stopDriver,
        stopDriverOfPdf,
    ]);
    // アクセス履歴の保存
    useEffect(() => {
        if (!UserPreviewState.isPreview && !isView) {
            const action = apiCreateClientOfferDetailViewEvent(id, viewRequestId, RFP_EVENT_TYPE_CLIENT_OFFER_VIEW);
            dispatch(action);
        }
    }, [id, viewRequestId, isView, dispatch]);
    const { onChangeSlideImage } = rfpOneOfferPageViewUseCase.useSaveViewEvent(id, viewRequestId, isShowFullModal, isMember, dispatch, 2000);
    const mainClass = 'rfp_common_container rfp_client_one_container is_public_offer_detail';
    const isDisabledBottom = !!(status !== OFFER_STATUS_SELECTION.value ||
        isEnd ||
        isDisabledAction);
    return (_jsxs(Layout, Object.assign({ bottomContent: _jsxs(_Fragment, { children: [_jsx(OfferOneBottom, { isDisabled: isDisabledBottom, onClickSendOff: onClickSendOff, rfp: rfp, viewRequest: viewRequest }), _jsx(RfpOneFooterNavSp, { id: id, isPreview: isPreview, nextViewRequestId: nextViewRequest.id, prevViewRequestId: prevViewRequest.id })] }), mainClassName: clsx('l-main no-need-bottom-space', DRIVER_PORTAL_ROOT_CLASS, mainClass) }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${offerTitle}｜PROFFIT` }) }), _jsx(Driver, { changeDriverState: changeDriverState, driverRef: driverRef, isLastInitialize: true, settings: driverSettings }), _jsx(Driver, { changeDriverState: changeDriverOfPdfState, driverRef: driverOfPdfRef, isLastInitialize: true, settings: driverOfPdfSettings }), _jsx(Breadcrumb, { lists: pans }), _jsx(RfpOneHeaderNavPc, { driverTargetRef: driverTargetThreeRef, id: id, isActiveDriverTarget: getIsActiveDriverTarget(2), isPreview: isPreview, nextViewRequestId: nextViewRequest.id, onClickDriverTarget: changeDriverTarget, prevViewRequestId: prevViewRequest.id, title: offerTitle }), _jsx(RfpOneDescriptionRow, { averagePeriod: averagePeriod, averagePrice: averagePrice, driverTargetOneRef: driverTargetOneRef, isActiveDriverTarget: getIsActiveDriverTarget(0), isSingleOffer: offers.length === 1, mainClass: mainClass, onClickDownload: onClickDownload, onClickDriverTarget: changeDriverTarget, onClickThumbnail: showFullModal, viewRequest: viewRequest }), _jsx(RfpOneDescriptionFixedRow, { charmPoint: charmPointValue, charmPoints: charmPoints, driverTargetTwoRef: driverTargetTwoRef, isActiveDriverTarget: getIsActiveDriverTarget(1), isDisabled: !isEnabledCharmPoint, onChangeCompleteInputRange: onChangeCompleteInputRange, onChangeInputRange: onChangeInputRange, onClickDriverTarget: isPc ? changeDriverTarget : stopDriver }), _jsxs("div", Object.assign({ className: 'rfp_one_offer_detail_container' }, { children: [_jsx("div", Object.assign({ className: 'rfp_one_offer_detail_container_left' }, { children: _jsx(MemberRows, { offerMembers: offerMembers }) })), _jsxs("div", Object.assign({ className: 'rfp_one_offer_detail_container_right' }, { children: [_jsx(CompanyRow, { viewRequest: viewRequest }), _jsx(AdditionalFilesRow, { additionalFiles: offer.additional_files })] }))] })), _jsx(SendOffModal, { hideModal: hideSendOffModal, isShow: isShowSendOffModal, modalValue: modalValue, onSubmit: onSubmitSendOff }), _jsx(FullScreenImageViewerModal, { bodyClassName: 'is_absolute', className: 'rfp_common_container rfp_client_one_container is_public_offer_detail is_absolute', hideFullModal: hideFullModal, images: fileImages, isShow: isShowFullModal, isShowDriver: getIsActiveDriverOfPdfTarget(0), onChangeSlideImage: onChangeSlideImage, rightClassName: 'full_screen_modal_right_client_offer_one', rightComponent: _jsx(RightComponent, { charmPoint: charmPointValue, charmPoints: charmPoints, confirmComment: confirmComment || '', driverOfPdfTargetOneRef: driverOfPdfTargetOneRef, goodPointComment: goodPointComment || '', isDisabled: isEnd, onChangeCompleteInputRange: onChangeCompleteInputRange, onChangeInputRange: onChangeInputRange, onClickDriverOfPdfTarget: stopDriverOfPdf }) })] })));
};
RfpOneOfferDetail.propTypes = {
    match: propMatch(),
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({
    redirectCallback: ({ match, offers, rfp }) => {
        const { params: { id, viewRequestId }, } = match;
        const exists = offers.some((v) => v.id.toString() === viewRequestId);
        const isPublic = isRfpTypePublicOffer(rfp.rfp_type);
        return exists && isPublic ? '' : `/project/client/${id}/offer`;
    },
}, RfpOneSkeleton));
export default enhance(RfpOneOfferDetail);
